<template>
    <div class="main-register-container">
        <div class="register-container">
            <div class="register-area stick-it">
                <div class="register-area-content">
                    <h1>Register</h1>
                    <p> Make a brand new <i class="em em-eyeglasses"></i> account </p>
                    <input v-model="user_data.first_name" :class="dynamic_reg_username_class" type="text" placeholder="FirstName"/>
                    <input v-model="user_data.last_name" :class="dynamic_reg_username_class" type="text" placeholder="LastName"/>
                    <input v-model="user_data.username" :class="dynamic_reg_username_class" type="email" placeholder="someone@example.com"/>
                    <!-- <input v-model="user_data.email" :class="dynamic_reg_email_class" type="email" placeholder="someone@example.com"/> -->
                    <input v-model="user_data.password" :class="dynamic_reg_pass_class" type="password" placeholder="Password"/>
                    <input v-model="confirmPass" type="password" :class="dynamic_reg_confirm_pass_class" placeholder="Confirm Password"/>
                    <select v-model="user_data.plan" :class="dynamic_reg_plan_class">
                        <option disabled value="">Select a Plan</option>
                        <option value="plan-e7a0e">PRO - 1 User - €99</option>
                        <option value="plan-sme-monthly">SME - 5 Users - €399</option>
                        <option value="plan-enterprise-monthly">Enterprise - 10 Users - €999</option>
                        <option value="plan-min">TestPlan - 1 User - €1</option>
                    </select>
                    
                    <!-- <span>Selected: {{ user_data.plan }}</span> -->

                    <div v-if= "isRegistering" class="registering">
                        <fulfilling-square-spinner
                                :animation-duration="4000"
                                :size="30"
                                color="white"
                                class="icon-loading"/>

                        <!-- <button type="button" class="btn-register"  @click="registerAccount"> -->
                        <button type="button" class="btn-register">
                            Register
                        </button>

                    </div>
                    <button v-else type="button" class="btn-register-not-loading"  @click="registerAccount">
                        Register
                    </button>


                    <!--<button type="button" class="btn-register" @click="registerAccount">Register</button>-->



                    <label class="already-have-account-label">Already have an account?
                        <router-link to="/login" class="click-register-label"> Click here</router-link>
                        to login.
                    </label>

                    <label :class="{hideError : no_reg_error}" class="login-error-label">
                        <i class="em em-warning"></i><span v-html="error_txt"></span>
                    </label>
                </div>
            </div>
            <div class="showcase-area">
                <!-- <agile :arrows="false" :speed="1000"
                    :timing="'linear'" :fade="true"
                    :autoplay="true" :pauseOnHover="true">
                    <div class="slide slide--1"></div>
                    <div class="slide slide--2"></div>
                    <div class="slide slide--3"></div>
                </agile> -->
                <agile :arrows="false" :speed="500" :autoplaySpeed = "7000"
                       :timing="'linear'" :fade="false"
                       :autoplay="true" :pauseOnHover="true">
                    <div class="slide slide--1">
                        <div class="slide-content">
                            <h1>AUGMENTED REALITY FOR INSTALLATION</h1>
                            <p>The first ever AR application for onsite layout planner use by pioneer and innovative companies</p>
                        </div>
                    </div>

                    <div class="slide slide--2">
                        <div class="slide-content">
                            <h1>THE USE OF AR TECHNOLOGY FOR MAINTENANCE</h1>
                            <p>Modern innovative tool to completely digitalize and contextualize models of the whole site with the ability to edit and share contextual notes</p>
                        </div>
                    </div>

                    <div class="slide slide--3">
                        <div class="slide-content">
                            <h1>DEMONSTRATION OF PRODUCTS TO CUSTOMERS</h1>
                            <p>An effective sales tool to mesmerize end-users with your products</p>
                        </div>
                    </div>
                </agile>
            </div>
        </div>
    </div>
</template>

<script>

    import { FulfillingSquareSpinner } from 'epic-spinners'
    export default {
        name: "Register",
        data: function () {
            return {
                user_data: {
                    username: "",
                    password: "",
                    email:'', 
                    plan:'',
                    first_name:'',
                    last_name:''
                },
                confirmPass:'',
                dynamic_reg_firstname_class: "",
                dynamic_reg_lastname_class: "",
                dynamic_reg_username_class: "",
                dynamic_reg_pass_class: "",
                dynamic_reg_confirm_pass_class: "",
                dynamic_reg_email_class: "",
                dynamic_reg_plan_class: "",
                no_reg_error: true,
                error_txt: '',
                isRegistering: false
            }
        },
        mounted: function() {
            this.checkifLoggedIn()
        },
        components: {
            FulfillingSquareSpinner
        },
        methods: {
            checkifLoggedIn(){
                console.log("loggedin: ",this.$store.state._user_authenticated);
                if(this.$store.state._user_authenticated){
                    this.$router.push('Home');
                }
            },
            registerAccount: function () {

                this.dynamic_reg_firstname_class = "";
                this.dynamic_reg_lastname_class = "";
                this.dynamic_reg_username_class = "";
                this.dynamic_reg_pass_class = "";
                this.dynamic_reg_confirm_pass_class = "";
                this.dynamic_reg_email_class = "";
                this.dynamic_reg_plan_class = "";
                this.no_reg_error = true;
                this.isRegistering = true;

                setTimeout(function () {
                    // if (this.user_data.username && this.user_data.password && this.user_data.email && (this.user_data.plan !="") && this.confirmPass ) {
                    if (this.user_data.first_name && this.user_data.last_name && this.user_data.username && this.user_data.password && (this.user_data.plan !="") && this.confirmPass ) {
                        if(this.user_data.plan === ""){
                            this.isRegistering = false;
                            this.dynamic_reg_plan_class = "animated shake border-error";
                            this.error_txt = 'Select a <span style="color: red; font-family: \'Roboto\', sans-serif; font-weight: bold; text-decoration: none;">Plan</span>.';
                            this.no_reg_error = false;
                        }
                        if(this.user_data.password === this.confirmPass){
                            this.user_data.email = this.user_data.username;
                            // this.user_data.first_name = "Carl";
                            // this.user_data.last_name = "Ross";
                            this.$store.dispatch('userRegistrationIndividual_with_Payment', this.user_data)
                                .then(() => {
                                    this.isRegistering = false;
                                    this.$router.push('Home');
                                })
                                .catch(() => {
                                    this.isRegistering = false;
                                    this.dynamic_reg_firstname_class = "animated shake border-error";
                                    this.dynamic_reg_lastname_class = "animated shake border-error";
                                    this.dynamic_reg_username_class = "animated shake border-error";
                                    // this.dynamic_reg_email_class = "animated shake border-error";
                                    this.dynamic_reg_pass_class = "animated shake border-error";
                                    this.dynamic_reg_plan_class = "animated shake";
                                    this.dynamic_reg_confirm_pass_class = "animated shake border-error";
                                    this.error_txt = ' Something went <span style="color: red; font-family: \'Roboto\', sans-serif; font-weight: bold; text-decoration: none;">wrong</span> account not ' +
                                        '<span style="color: red; font-family: \'Roboto\', sans-serif; font-weight: bold; text-decoration: none;"> registered! </span>.';
                                    this.no_reg_error = false;
                                })
                        } else {
                            // Password does not match
                            this.isRegistering = false;
                            this.dynamic_reg_pass_class = "animated shake border-error";
                            this.dynamic_reg_confirm_pass_class = "animated shake border-error";
                            this.error_txt = '<span style="color: red; font-family: \'Roboto\', sans-serif; font-weight: bold; text-decoration: none;">Password</span> and ' +
                                '<span style="color: red; font-family: \'Roboto\', sans-serif; font-weight: bold; text-decoration: none;"> Confirm password </span> should be same.';
                            this.no_reg_error = false;
                        }
                    } else {
                        this.no_reg_error = false;
                        this.isRegistering = false;
                        // if (!this.user_data.username && !this.user_data.password && !this.user_data.email && !this.confirmPass) {
                        if (!this.user_data.username && !this.user_data.password && !this.confirmPass) {
                            this.dynamic_reg_username_class = "animated shake border-error";
                            // this.dynamic_reg_email_class = "animated shake border-error";
                            this.dynamic_reg_pass_class = "animated shake border-error";
                            this.dynamic_reg_plan_class = "animated shake ";
                            this.dynamic_reg_confirm_pass_class = "animated shake border-error";
                            this.error_txt = '<span style="color: red; font-family: \'Roboto\', sans-serif; font-weight: bold; text-decoration: none;"> Any field must not be empty.</span>';
                        } else {
                            let empty_fields = '';

                            if (!this.user_data.username) {
                                this.dynamic_reg_username_class = "animated shake border-error";
                                // empty_fields = 'Username'
                                empty_fields = empty_fields + ', Email'
                            }
                            if (!this.user_data.password) {
                                this.dynamic_reg_pass_class = "animated shake border-error";
                                empty_fields = empty_fields + ', Password'
                            }
                            // if (!this.user_data.email) {
                            //     this.dynamic_reg_email_class = "animated shake border-error";
                            //     empty_fields = empty_fields + ', Email'
                            // }
                            if (!this.confirmPass) {
                                this.dynamic_reg_confirm_pass_class = "animated shake border-error";
                                empty_fields = empty_fields + ', Confirm Password'
                            }
                            if (!this.user_data.plan) {
                                this.dynamic_reg_plan_class = "animated shake";
                                empty_fields = empty_fields + ', Plan'
                            }

                            if(empty_fields.charAt( 0 ) === ',') empty_fields = empty_fields.slice(1);
                            if(empty_fields.charAt( empty_fields.length - 1 ) === ',') empty_fields = empty_fields.slice(1);

                            this.error_txt = '<span style="color: red; font-family: \'Roboto\', sans-serif; font-weight: bold; text-decoration: none;">'+ empty_fields +' must not be empty.</span>';
                        }
                    }
                }.bind(this), 100);



            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "@/assets/css/colors.scss";

    %flex-center-content {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .border-error{
        box-shadow: 0 0 5px 0 red;
        border: 5px solid red;
    }

    .hideError{
        visibility: hidden;
    }

    .stick-it {
        position: sticky;
        position: -webkit-sticky;
        top: 0;
    }
    
    .main-register-container{
        width: 100%;
        height: 100%;
        background: #fff url('http://i.picpar.com/ztld.png') no-repeat 50% 50%;
        background-size: cover;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .register-container {
        width: 95%;
        height: 90%;
        top: 0;
        box-shadow: 0 0 30px 0 black;
        margin: 0;
        padding: 0;
        display: grid;
        background-color: transparent;
        grid-template-areas: "register-form register-showcase";
        grid-template-rows: 1fr;
        // grid-template-rows: repeat(1, 100vh);
        grid-template-columns: 40% 60%;
        overflow: hidden;
    }

    .register-area {
        grid-area: register-form;
        width: 100%;
        height: 100vh;
        background-color: white;
        margin: auto;
        padding: 0;
        @extend %flex-center-content;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        overflow: hidden;
    }

    .register-area .register-area-content {
        background-color: white;
        width: 90%;
        padding: 0 10% 20% 10%;
        max-height: 100%;
        display: table-cell;
        vertical-align: middle;
        border-radius: 20px;
    }

    .register-area-content input[type=text], input[type=password], input[type=email] , select{
        width: 100%;
        border: 2px solid $primary-color;
        margin: 8px 0;
        outline: none;
        padding: 20px;
        box-sizing: border-box;
        transition: 0.3s;
        font-family: 'Roboto', sans-serif;
        font-size: 120%;
        letter-spacing: 1px;
    }

    .register-area-content input[type=text]:focus, input[type=password]:focus, input[type=email]:focus ,select:focus{
        font-family: 'Roboto', sans-serif;
        border-color: $primary-color;
        box-shadow: 0 0 5px 0 $primary-color;
    }

    .register-area-content input[type=checkbox] {
        position: relative;
        width: 20px;
        height: 20px;
        margin-right: 2%;
        -moz-appearance: none;
        -ms-progress-appearance: unset;
        -webkit-appearance: none;
        outline: none;
        transition: .3s;
        cursor: pointer;
    }

    .register-area-content input[type=checkbox]:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 2px solid #aaa;
        box-sizing: border-box;
        transition: .3s;
    }

    .register-area-content input:checked[type=checkbox]:before {
        border-left: none;
        border-top: none;
        width: 40%;
        border-color: $primary-color;
        transform: rotate(45deg) translate(15%, -20%);
    }
    
    .register-area-content .rem-forgot-container{
        display: flex;
        flex-direction: row;
        width: 100%;
    }

    .register-area-content .remember-me-label {
        color: #545454;
        font-family: 'Roboto', sans-serif;
        font-size: 120%;
        line-height: 150%;
        font-weight: normal;
        cursor: pointer;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: left;
        /*vertical-align: middle;*/
    }

    .register-area-content .forgot-password {
        color: $primary-color;
        font-family: 'Roboto', sans-serif;
        font-size: 120%;
        line-height: 150%;
        font-weight: normal;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: right;
        text-align: right;

    }

    .register-area-content .btn-register {
        width: 100%;
        // border-radius: 0 15px 15px 0;
        outline: none;
        padding: 4%;
        box-sizing: border-box;
        transition: 0.3s;
        font-family: 'Roboto', sans-serif;
        font-size: 120%;
        color: white;
        font-weight: bolder;
        background: $primary-color;
        /*background: linear-gradient(90deg, blueviolet, #e281da);*/
        clear: both;
        float: left;
        cursor: pointer;
        border: none;
    }

    .icon-loading{
        margin: 0 4%;
    }

    .register-area-content .btn-register-not-loading {
        width: 100%;
        // border-radius:15px;
        margin: 5% 0;
        outline: none;
        padding: 4%;
        box-sizing: border-box;
        transition: 0.3s;
        font-family: 'Roboto', sans-serif;
        font-size: 120%;
        color: white;
        font-weight: bolder;
        background: $primary-color;
        /*background: linear-gradient(90deg, blueviolet, #e281da);*/
        clear: both;
        float: left;
        cursor: pointer;
        border: none;
    }

    .registering{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
        align-items: center;
        background-color: $primary-color;
        margin: 5% 0;
        border-radius:15px;
    }

    .register-area-content .already-have-account-label {
        clear: both;
        float: left;
        width: 100%;
        text-align: center;
        color: #545454;
        font-family: 'Roboto', sans-serif;
        font-size: 100%;
        margin: 8% 0;
        letter-spacing: 1px;
    }

    .register-area-content .click-register-label {
        color: $primary-color;
        font-family: 'Roboto', sans-serif;
        font-weight: bold;
        text-decoration: none;
    }

    .register-area-content .click-register-label:hover {
        text-decoration: underline;
    }

    .register-area img {
        width: 150%;
        height: auto;
        opacity: 0.15;
        position: absolute;
        margin-left: 5%;
        min-width: 100%;
         -webkit-transition: all 5s ease; /* Safari and Chrome */
         -moz-transition: all 5s ease; /* Firefox */
         -o-transition: all 5s ease; /* IE 9 */
         -ms-transition: all 5s ease; /* Opera */
        transition: all 5s ease;
    }

    .register-area:hover img {
         -webkit-transform: scale(1.10); /* Safari and Chrome */
         -moz-transform: scale(1.10); /* Firefox */
         -ms-transform: scale(1.10); /* IE 9 */
         -o-transform: scale(1.10); /* Opera */
        transform: scale(1.10);
    }

    .register-area h1 {
        color: $primary-color;
        font-family: 'Roboto Slab', sans-serif;
        font-size: 300%;
        width: 100%;
        margin: 10% 0 2% 0;
        text-align: center;
    }

    .register-area p {
        color: #545454;
        font-family: 'Roboto', sans-serif;
        font-size: 120%;
        margin: 2% 0 5% 0;
        line-height: 150%;
        font-weight: lighter;
        text-align: center;
    }

    .showcase-area {
        grid-area: register-showcase;
        width: 100%;
        height: 100%;
        margin: auto;
        top: 0;
        padding: 0;
        background-color: transparent;

    }
    .slide {
        height: 90vh;
        display: flex;
        align-items: center;
        padding: 1%;

        .slide-content{
            h1{
                font-family: 'Roboto', sans-serif;
                font-size: 200%;
                width: 100%;
                margin-bottom: 2%;
                color: white;
                text-align: left;
                font-weight: bolder;
            }

            p{
                font-family: 'Roboto Slab', sans-serif;
                font-size: 120%;
                margin: 2% 0 5% 0;
                line-height: 150%;
                font-weight: lighter;
                color: white;
                text-align: left;
            }
        }

        &:before {
            background: transparent;
            content: '';
            height: 100%;
            left: 0;
            position: absolute;
            top: 0;
            width: 100%;
        }

        &--1 {
            background: transparent;
        }

        &--2 {
            background: transparent;
        }

        &--3 {
            background: transparent;
        }
    }
    // .slide {
    //     height: 100vh;

    //     &:before {
    //         background-color: rgba(#000, .2);
    //         content: '';
    //         height: 100%;
    //         left: 0;
    //         position: absolute;
    //         top: 0;
    //         width: 100%;
    //     }

    //     &--1 {
    //         background: #fff url('https://images.pexels.com/photos/1657110/pexels-photo-1657110.jpeg') no-repeat 50% 50%;
    //         background-size: cover;
    //     }

    //     &--2 {
    //         background: #fff url('https://images.pexels.com/photos/1870320/pexels-photo-1870320.jpeg') no-repeat 50% 50%;
    //         background-size: cover;
    //     }

    //     &--3 {
    //         background: #fff url('https://images.pexels.com/photos/1441932/pexels-photo-1441932.jpeg') no-repeat 50% 50%;
    //         background-size: cover;
    //     }
    // }

    /* MEDIA QUERIES */

    /*
      ##Device = Desktops
      ##Screen = 1281px to higher resolution desktops
    */

    @media (min-width: 1281px) {


    }

    /*
      ##Device = Laptops, Desktops
      ##Screen = B/w 1025px to 1280px
    */

    @media (min-width: 950px) and (max-width: 1280px) {

        /* //CSS */
        .register-area .register-area-content .remember-me-label {
            font-size: 90%;
        }

        .register-area .register-area-content .forgot-password {
            font-size: 90%;

        }


    }

    @media (max-width: 949px)  {




        .register-area .register-area-content .remember-me-label {
            font-size: 90%;
        }

        .register-area .register-area-content .forgot-password {
            font-size: 90%;

        }
    }

    /*
      ##Device = Low Resolution Tablets, Mobiles (Landscape)
      ##Screen = B/w 481px to 767px
    */

    @media (min-width: 481px) and (max-width: 767px) {

        .register-area .register-area-content {
            width: 90%;
        }

        .register-area-content h1 {
            font-size: 200%;
        }

        .register-area-content p {
            font-size: 100%;
        }

        .register-area-content input[type=text], input[type=password] , select {

            font-size: 100%;
        }

        .register-area-content input[type=text]:focus, input[type=password]:focus ,select:focus{
            font-size: 100%;
        }

        .register-area-content input[type=checkbox] {
            width: 15px;
            height: 15px;
        }

        .register-area-content .remember-me-label {
            font-size: 100%;
        }


        .register-area-content .forgot-password {
            font-size: 100%;
            font-weight: normal;
            float: right;
            margin: 3% 0;
            cursor: pointer;

        }

        .register-area-content .btn-login {
            font-size: 100%;
        }

        .register-area-content .no-account-label {
            font-size: 85%;
        }

        .register-area-content .register-error-label {
            font-size: 85%;
        }

    }

    /*
      ##Device = Most of the Smartphones Mobiles (Portrait)
      ##Screen = B/w 320px to 479px
    */

    @media (min-width: 320px) and (max-width: 480px) {

        .register-area .register-area-content {
            width: 90%;
        }

        .register-area .register-area-content h1 {
            font-size: 200%;
        }

        .register-area .register-area-content p {
            font-size: 100%;
        }

        .register-area .register-area-content input[type=text], input[type=password], select {

            font-size: 100%;
        }

        .register-area .register-area-content input[type=text]:focus, input[type=password]:focus, select:focus {
            font-size: 100%;
        }

        .register-area .register-area-content input[type=checkbox] {
            width: 15px;
            height: 15px;
        }

        .register-area .register-area-content .remember-me-label {
            font-size: 80%;
        }

        .register-area .register-area-content .forgot-password {
            font-size: 80%;

        }

        .register-area .register-area-content .btn-login {
            font-size: 100%;
        }

        .register-area .register-area-content .no-account-label {
            font-size: 85%;
        }

        .register-area .register-area-content .register-error-label {
            font-size: 85%;
        }
    }
</style>